<template>
  <div>
    <p v-text="'Marcas a serem cotadas:'" class="subtitle-2 font-weight-medium" />

    <div style="height: 49vh;overflow: auto">
      <template v-for="(item, _index) in fornecedoresSelecionados">
        <v-chip
          :key="_index"
          outlined
          small
          color="#00726B"
          style="background: #ebf1f1 !important;"
          class="mr-2 mb-2"
        >
          <v-icon small left @click="removerItem(item)">mdi-close</v-icon>
          <span v-text="item.nome_fornecedor" />
        </v-chip>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "MarcasASeremCotadas",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: Array,
      required: true
    }
  },
  computed: {
    fornecedoresSelecionados: {
      get: function () {
        return this.modelValue;
      },
      set: function (value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  methods: {
    removerItem(item) {
      this.fornecedoresSelecionados = this.fornecedoresSelecionados.filter(f => f !== item);
    }
  }
}
</script>

<style scoped>

</style>
